module.exports = __webpack_public_path__ + "static/media/sobre.2a0aa1fd.jpg";